import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'ui';

import GeneratingRobot from './GeneratingRobot';
import './GeneratingSessionDialog.scss';

/**
 * GeneratingSessionDialog - Popup 3 of the custom practice flow (TANAI-1869).
 * Shows the loading robot while the practice session is being generated.
 */

type GeneratingSessionDialogProps = {
  isOpen: boolean;
};

function GeneratingSessionDialog({ isOpen }: GeneratingSessionDialogProps): JSX.Element {
  const { t } = useTranslation(['chatbot']);

  return (
    <Dialog className="generating-session-dialog" isCloseButtonHidden isOpen={isOpen} size="m" title={t('practice_more_generating')}>
      <div className="generating-session-dialog__content">
        <GeneratingRobot />
      </div>
    </Dialog>
  );
}

export default GeneratingSessionDialog;
